import { FormViewField } from 'components/FormView';

export default {
  formName: 'PickSlipFilterRow',
  validate: null,
  rowModelType: 'serverSide',
  parameters: [
    {
      id: 1,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Customer',
        name: 'CustomerId',
        lookupName: 'Customer',
        placeholder: '',
        required: false,
        size: 'small',
        searchScreenAPIParms: { Type: 'LOOKUP' }
      }
    },
    {
      id: 2,
      type: 'TEXT_FIELD',
      props: {
        label: 'Invoice',
        name: 'Invoice',
        placeholder: '',
        required: false,
        size: 'small',
      }
    },
    {
      id: 3,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Entity view',
        name: 'EntityView',
        lookupName: 'EntityView',
        size: 'small',
        required: true
      }
    },
    {
      id: 4,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Warehouse',
        name: 'Warehouse',
        lookupName: 'WarehouseEntity',
        size: 'small',
        required: false
      }
    },
    {
      id: 5,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Sales entity',
        size: 'small',
        name: 'SalesEntity',
        lookupName: 'SalesEntity',
        disabled: false,
        isEntityScoped: true,
        suppressDescription: true
      }
    },
    {
      id: 6,
      type: 'AUTOCOMPLETE_FIELD',
      props: {
        label: 'Status',
        name: 'Status',
        required: false,
        apiPrefs: {
          path: '/CustomTypes/Lookup/SearchPickSlipStatusOption/Search',
          method: 'POST',
          params: {
            BatchSize: 20
          }
        },
      }
    },
    {
      id: 7,
      type: 'SELECT_FIELD',
      props: {
        label: '',
        name: 'Finalised',
        defaultValue: 'False',
        options: [
          {
            value: 'False',
            label: 'Unfinalised',
            default: true
          },
          {
            value: 'True',
            label: 'Finalised'
          }
        ]
      }
    },
  ] as FormViewField[]
};
